import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import '../css/calendario.css';

function Calendario(props) {

    const [value, onChange] = useState(fechaInicial);
    const [minDate, setMinDate] = useState(fechaInicial);

    function cambioFecha() {

        let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(value);
        let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(value);
        let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(value);
        let fecha = ye + "-" + mo + "-" + da;
        props.setFecha(fecha);
        //caracteristicas.buscarTurnos();
    }

    function ocultarCalendario() {
        document.getElementById("calendario-" + props.id).classList.add("d-none");
    }
    useEffect(() => {
        cambioFecha();
        ocultarCalendario();
    }, [value])

    useEffect(() => {
        if (props.restart > 0 && props.restart !== null) {
            onChange(fechaInicial);
        }
    }, [props.restart])

    useEffect(() => {
        if (props.isSetDate > 0 && props.isSetDate !== null) { 
            const date = new Date(props.fecha)
            date.setDate(date.getDate() + 1);
            onChange(date);
        }
    }, [props.isSetDate])

    useEffect(() => {
        document.addEventListener("click", function (e) {
            var calendario = document.getElementById('calendario-' + props.id);
            if (e.target == calendario) {
                calendario.classList.add('d-none');
            }
        }, false);
    }, [])
    function fechaInicial() {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        return date;
    }
    return (
        <>
            {/*<input id="fechaSeleccionada" class="col-6 " type="date" onChange={cambioFecha}/>*/}
            <div id={"calendario-" + props.id} class=" d-none  contenedorCalendario centrarContainer">
                <Calendar
                    onChange={onChange}
                    value={value}
                    //showNavigation={false}
                    minDate={minDate}
                    navigationLabel={({ date, label, locale }) => `${label.replace(' de', '')}`}
                    view={"month"}
                />

            </div>
        </>
    );
}


export default Calendario;